"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-fifteen/section/heroSection.tsx */

import { LandingSiteTemplateGetDataMenuOutputApiModel } from "@/Apis/ClinicApi";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import HeaderNav from "../../Components/HeaderNav";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider, { type Settings } from "react-slick";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type HeroSectionSupport3sItem = {
    key: Key | null | undefined;
    /** Detected variants: "support-item mb-3" | "support-item" */
    className: string;
    /** Detected variants: "isax isax-messages-3" | "isax isax-call-calling" */
    i0ClassName: string;
    /** Detected variants: "info@example.com" | "+1 24565 89856" */
    h30Text: ReactNode;
    /** Detected variants: "General Inquiries" | "Emergency Cases" */
    p0Text: ReactNode;
    /** Detected variants: "avatar avatar-lg bg-primary rounded-circle" */
    div0ClassName?: string;
    /** Detected variants: "link" */
    h30ClassName?: string;
    /** Detected variants: "title" */
    p0ClassName?: string;
};

type HeroSectionBtnBtnPrimariesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Sign" | "Sign In" */
    linkText: ReactNode;
    /** Detected variants: "Sign In" */
    ariaLabel?: string;
    /** Detected variants: "btn btn-primary" */
    className?: string;
    /** Detected variants: "all_routes.login" */
    href?: string;
    /** Detected variants: "isax isax-lock-1 me-2" */
    i0ClassName?: string;
};

type HeroSectionSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/banner/banner-slide-1.jpg" | "/Templates/Doccure/img/banner/banner-slide-2.jpg" | "/Templates/Doccure/img/banner/banner-slide-3.jpg" */
    src: string;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "banner" */
    alt?: string;
    /** Detected variants: "img-fluid slide-img" */
    imageWithBasePath0ClassName?: string;
};

type HeroSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "Facebook" | "Twitter" | "Instagram" | "LinkedIn" */
    ariaLabel: string;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "social-icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
};
const settings: Settings = {
    dots: true,
    appendDots: (dots) => (
        <ul className="custom-dots">
            {dots}
        </ul>
    ),
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000, // adjust if needed
    arrows: false,
    fade: true,
    responsive: [
        {
            breakpoint: 1400,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
};

export type HomeFifteenHeroSectionGeneratedProps = {
    menus: LandingSiteTemplateGetDataMenuOutputApiModel[];
    isScrolled?: boolean;
    onMobileBtn?: MouseEventHandler<HTMLAnchorElement>;
    onMenuClose?: MouseEventHandler<HTMLButtonElement>;
    divDiv0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: HeroSectionSupport3sItem) => Partial<ComponentProps<"h3">>);
    /** Default: "#" */
    divHeader0Div0Nav0Div0Link0LinkHref?: string;
    /** Default: "mobile_btn" */
    divHeader0Div0Nav0Div0Link0LinkId?: string;
    divHeader0Div0Nav0Div0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.home" */
    divHeader0Div0Nav0Div0Link1LinkHref?: string;
    divHeader0Div0Nav0Div0Link1LinkVisible?: boolean;
    divHeader0Div0Nav0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-white-02.svg" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc?: string;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible?: boolean;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-15.svg" */
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageSrc?: string;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageVisible?: boolean;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "close" */
    divHeader0Div0Nav0Div1Div0Button0ButtonAriaLabel?: string;
    /** Default: "menu_close" */
    divHeader0Div0Nav0Div1Div0Button0ButtonId?: string;
    divHeader0Div0Nav0Div1Div0Button0ButtonVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "all_routes.home" */
    divHeader0Div0Nav0Div1Div0Link0LinkHref?: string;
    divHeader0Div0Nav0Div1Div0Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Logo" */
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/logo-15.svg" */
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc?: string;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible?: boolean;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Contact Information" */
    divHeader0Div0Nav0Div1Div1Div0H30H3Text?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div0H30H3Visible?: boolean;
    divHeader0Div0Nav0Div1Div1Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Follow Us" */
    divHeader0Div0Nav0Div1Div1Div1H30H3Text?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div1H30H3Visible?: boolean;
    divHeader0Div0Nav0Div1Div1Div1H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div1H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "all_routes.register" */
    divHeader0Div0Nav0Div1Div1Div2Link2LinkHref?: string;
    /** Default: "Sign Up" */
    divHeader0Div0Nav0Div1Div1Div2Link2LinkText?: ReactNode;
    divHeader0Div0Nav0Div1Div1Div2Link2LinkVisible?: boolean;
    divHeader0Div0Nav0Div1Div1Div2Link2LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div1Div1Div2Link2LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.booking" */
    divHeader0Div0Nav0Div2Link0LinkHref?: string;
    /** Default: "Book A Consultation" */
    divHeader0Div0Nav0Div2Link0LinkText?: ReactNode;
    divHeader0Div0Nav0Div2Link0LinkVisible?: boolean;
    divHeader0Div0Nav0Div2Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divHeader0Div0Nav0Div2Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "banner" */
    divImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/overlay-img.png" */
    divImageWithBasePath0ImageSrc?: string;
    divImageWithBasePath0ImageVisible?: boolean;
    divImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeroSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divImageWithBasePath0ImagePropsSingleton?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    divSection0Div0Div0ClassName?: string;
    /** Default: "2s" */
    divSection0Div0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "tel:+12456589856" */
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkHref?: string;
    /** Default: "+1 24565 89856" */
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkText?: ReactNode;
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkVisible?: boolean;
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Call Us" */
    divSection0Div0Div0Div0Div0Div0Div0Div1P0PText?: ReactNode;
    /** Default: "#" */
    divSection0Div0Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Begin Your Journey" */
    divSection0Div0Div0Div0Div0Div0Link0LinkText?: ReactNode;
    divSection0Div0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    divSection0Div0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "Your Journey to" */
    divSection0Div0Div0Div0Div0H10H1Text?: ReactNode;
    divSection0Div0Div0Div0Div0H10H1Visible?: boolean;
    divSection0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divSection0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "Wellness" */
    divSection0Div0Div0Div0Div0H10Span0SpanText?: ReactNode;
    /** Default: "Mental" */
    divSection0Div0Div0Div0Div0H10Span0Span0SpanText?: ReactNode;
    /** Default: "Compassionate, evidence-based therapy and counseling services to help you thrive. Connect with licensed professionals who truly understand and care." */
    divSection0Div0Div0Div0Div0P0PText?: ReactNode;
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeroSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeroSectionBtnBtnPrimariesItem) => Partial<ComponentProps<typeof SmartLink>>);
    heroSectionSupport3s: HeroSectionSupport3sItem[];
    heroSectionBtnBtnPrimaries: HeroSectionBtnBtnPrimariesItem[];
    heroSectionSlides: HeroSectionSlidesItem[];
    heroSectionUls: HeroSectionUlsItem[];
    heroSectionSupport3sItemWrapper?: (item: HeroSectionSupport3sItem, content: ReactNode) => ReactNode;
    heroSectionSupport3sRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionSupport3sH3Visible?: boolean;
    heroSectionSupport3sH3Renderer?: (item: HeroSectionSupport3sItem, defaultNode: ReactNode) => ReactNode;
    heroSectionSupport3sH3Props?: Partial<ComponentProps<"h3">> | ((item: HeroSectionSupport3sItem) => Partial<ComponentProps<"h3">>);
    heroSectionBtnBtnPrimariesItemWrapper?: (item: HeroSectionBtnBtnPrimariesItem, content: ReactNode) => ReactNode;
    heroSectionBtnBtnPrimariesRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionBtnBtnPrimariesLinkVisible?: boolean;
    heroSectionBtnBtnPrimariesLinkRenderer?: (item: HeroSectionBtnBtnPrimariesItem, defaultNode: ReactNode) => ReactNode;
    heroSectionBtnBtnPrimariesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeroSectionBtnBtnPrimariesItem) => Partial<ComponentProps<typeof SmartLink>>);
    heroSectionSlidesItemWrapper?: (item: HeroSectionSlidesItem, content: ReactNode) => ReactNode;
    heroSectionSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionSlidesImageVisible?: boolean;
    heroSectionSlidesImageRenderer?: (item: HeroSectionSlidesItem, defaultNode: ReactNode) => ReactNode;
    heroSectionSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: HeroSectionSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    heroSectionUlsItemWrapper?: (item: HeroSectionUlsItem, content: ReactNode) => ReactNode;
    heroSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    heroSectionUlsLinkVisible?: boolean;
    heroSectionUlsLinkRenderer?: (item: HeroSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    heroSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: HeroSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeFifteenHeroSectionGenerated: FC<HomeFifteenHeroSectionGeneratedProps> = ({
    menus,
    isScrolled,
    onMobileBtn,
    onMenuClose,
    divHeader0Div0Nav0Div0Link0LinkHref = "#",
    divHeader0Div0Nav0Div0Link0LinkId = "mobile_btn",
    divHeader0Div0Nav0Div0Link0LinkVisible,
    divHeader0Div0Nav0Div0Link0LinkRenderer,
    divHeader0Div0Nav0Div0Link0LinkProps,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt = "Logo",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-white-02.svg",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageAlt = "Logo",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/logo-15.svg",
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageVisible,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageRenderer,
    divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageProps,
    divHeader0Div0Nav0Div0Link1LinkHref = "all_routes.home",
    divHeader0Div0Nav0Div0Link1LinkVisible,
    divHeader0Div0Nav0Div0Link1LinkRenderer,
    divHeader0Div0Nav0Div0Link1LinkProps,
    divHeader0Div0Nav0Div1Div0Button0ButtonAriaLabel = "close",
    divHeader0Div0Nav0Div1Div0Button0ButtonId = "menu_close",
    divHeader0Div0Nav0Div1Div0Button0ButtonVisible,
    divHeader0Div0Nav0Div1Div0Button0ButtonRenderer,
    divHeader0Div0Nav0Div1Div0Button0ButtonProps,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt = "Logo",
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/logo-15.svg",
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer,
    divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps,
    divHeader0Div0Nav0Div1Div0Link0LinkHref = "all_routes.home",
    divHeader0Div0Nav0Div1Div0Link0LinkVisible,
    divHeader0Div0Nav0Div1Div0Link0LinkRenderer,
    divHeader0Div0Nav0Div1Div0Link0LinkProps,
    divHeader0Div0Nav0Div1Div1Div0H30H3Text = "Contact Information",
    divHeader0Div0Nav0Div1Div1Div0H30H3Visible,
    divHeader0Div0Nav0Div1Div1Div0H30H3Renderer,
    divHeader0Div0Nav0Div1Div1Div0H30H3Props,
    divHeader0Div0Nav0Div1Div1Div1H30H3Text = "Follow Us",
    divHeader0Div0Nav0Div1Div1Div1H30H3Visible,
    divHeader0Div0Nav0Div1Div1Div1H30H3Renderer,
    divHeader0Div0Nav0Div1Div1Div1H30H3Props,
    divHeader0Div0Nav0Div1Div1Div2Link2LinkHref = "all_routes.register",
    divHeader0Div0Nav0Div1Div1Div2Link2LinkText = "Sign Up",
    divHeader0Div0Nav0Div1Div1Div2Link2LinkVisible,
    divHeader0Div0Nav0Div1Div1Div2Link2LinkRenderer,
    divHeader0Div0Nav0Div1Div1Div2Link2LinkProps,
    divHeader0Div0Nav0Div2Link0LinkHref = "all_routes.booking",
    divHeader0Div0Nav0Div2Link0LinkText = "Book A Consultation",
    divHeader0Div0Nav0Div2Link0LinkVisible,
    divHeader0Div0Nav0Div2Link0LinkRenderer,
    divHeader0Div0Nav0Div2Link0LinkProps,
    divImageWithBasePath0ImageAlt = "banner",
    divImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/overlay-img.png",
    divImageWithBasePath0ImageVisible,
    divImageWithBasePath0ImageRenderer,
    divImageWithBasePath0ImageProps,
    divImageWithBasePath0ImagePropsSingleton,
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkHref = "tel:+12456589856",
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkText = "+1 24565 89856",
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkVisible,
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkRenderer,
    divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkProps,
    divSection0Div0Div0Div0Div0Div0Div0Div1P0PText = "Call Us",
    divSection0Div0Div0Div0Div0Div0Link0LinkHref = "#",
    divSection0Div0Div0Div0Div0Div0Link0LinkText = "Begin Your Journey",
    divSection0Div0Div0Div0Div0Div0Link0LinkVisible,
    divSection0Div0Div0Div0Div0Div0Link0LinkRenderer,
    divSection0Div0Div0Div0Div0Div0Link0LinkProps,
    divSection0Div0Div0Div0Div0DivDataWowDuration = "2s",
    divSection0Div0Div0Div0Div0H10H1Text = "Your Journey to",
    divSection0Div0Div0Div0Div0H10H1Visible,
    divSection0Div0Div0Div0Div0H10H1Renderer,
    divSection0Div0Div0Div0Div0H10H1Props,
    divSection0Div0Div0Div0Div0H10Span0Span0SpanText = "Mental",
    divSection0Div0Div0Div0Div0H10Span0SpanText = "Wellness",
    divSection0Div0Div0Div0Div0P0PText = "Compassionate, evidence-based therapy and counseling services to help you thrive. Connect with licensed professionals who truly understand and care.",
    divDiv0Slider0SliderProps,
    divDiv1H30H3Props,
    liLink0LinkProps,
    linkLinkProps,
    divSection0Div0Div0ClassName,
    heroSectionSupport3s,
    heroSectionBtnBtnPrimaries,
    heroSectionSlides,
    heroSectionUls,
    heroSectionSupport3sItemWrapper,
    heroSectionSupport3sRenderer,
    heroSectionSupport3sH3Visible,
    heroSectionSupport3sH3Renderer,
    heroSectionSupport3sH3Props,
    heroSectionBtnBtnPrimariesItemWrapper,
    heroSectionBtnBtnPrimariesRenderer,
    heroSectionBtnBtnPrimariesLinkVisible,
    heroSectionBtnBtnPrimariesLinkRenderer,
    heroSectionBtnBtnPrimariesLinkProps,
    heroSectionSlidesItemWrapper,
    heroSectionSlidesRenderer,
    heroSectionSlidesImageVisible,
    heroSectionSlidesImageRenderer,
    heroSectionSlidesImageProps,
    heroSectionUlsItemWrapper,
    heroSectionUlsRenderer,
    heroSectionUlsLinkVisible,
    heroSectionUlsLinkRenderer,
    heroSectionUlsLinkProps,
}) => {
    return (
        <div className="hero-section-fifteen">
            <div className="hero-slider-fifteen">
                <Slider {...settings} {...(divDiv0Slider0SliderProps ?? {})}>
                    {renderCollectionNode(
                        heroSectionSlides,
                        (item: HeroSectionSlidesItem) => (
                            <div className={item.className ?? "slide-item"} key={item.key}>
                                {renderItemNode(heroSectionSlidesImageVisible, heroSectionSlidesImageRenderer, item, (
                                    <SmartImage src={item.src} alt={item.alt ?? "banner"} className={item.imageWithBasePath0ClassName ?? "img-fluid slide-img"} {...(typeof heroSectionSlidesImageProps === "function" ? heroSectionSlidesImageProps(item) : (heroSectionSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                ))}
                            </div>
                        ),
                        heroSectionSlidesItemWrapper,
                        heroSectionSlidesRenderer
                    )}
                </Slider>
            </div>
            <header className={isScrolled ? "header header-fifteen fixed" : "header header-fifteen"}>
                <div className="container">
                    <nav className="navbar navbar-expand-lg header-nav">
                        <div className="navbar-header">
                            {renderNode(divHeader0Div0Nav0Div0Link0LinkVisible, divHeader0Div0Nav0Div0Link0LinkRenderer, (
                                <SmartLink id={divHeader0Div0Nav0Div0Link0LinkId} href={divHeader0Div0Nav0Div0Link0LinkHref} onClick={onMobileBtn} {...(divHeader0Div0Nav0Div0Link0LinkProps ?? {})}>
                                    <i className="fa-solid fa-bars" />
                                </SmartLink>
                            ))}
                            {renderNode(divHeader0Div0Nav0Div0Link1LinkVisible, divHeader0Div0Nav0Div0Link1LinkRenderer, (
                                <SmartLink href={divHeader0Div0Nav0Div0Link1LinkHref} className="navbar-brand logo" {...(divHeader0Div0Nav0Div0Link1LinkProps ?? {})}>
                                    {renderNode(divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageVisible, divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageSrc} className="img-fluid white-logo" alt={divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageAlt} {...(divHeader0Div0Nav0Div0Link1ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                    {renderNode(divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageVisible, divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageRenderer, (
                                        <SmartImage src={divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageSrc} className="img-fluid normal-logo" alt={divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageAlt} {...(divHeader0Div0Nav0Div0Link1ImageWithBasePath1ImageProps ?? {})} />
                                    ))}
                                </SmartLink>
                            ))}
                        </div>
                        <div className="main-menu-wrapper">
                            <div className="menu-header">
                                {renderNode(divHeader0Div0Nav0Div1Div0Link0LinkVisible, divHeader0Div0Nav0Div1Div0Link0LinkRenderer, (
                                    <SmartLink href={divHeader0Div0Nav0Div1Div0Link0LinkHref} className="menu-logo" {...(divHeader0Div0Nav0Div1Div0Link0LinkProps ?? {})}>
                                        {renderNode(divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageVisible, divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageSrc} className="img-fluid" alt={divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageAlt} {...(divHeader0Div0Nav0Div1Div0Link0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </SmartLink>
                                ))}
                                {renderNode(divHeader0Div0Nav0Div1Div0Button0ButtonVisible, divHeader0Div0Nav0Div1Div0Button0ButtonRenderer, (
                                    <button type="button" id={divHeader0Div0Nav0Div1Div0Button0ButtonId} className="menu-close" aria-label={divHeader0Div0Nav0Div1Div0Button0ButtonAriaLabel} onClick={onMenuClose} {...(divHeader0Div0Nav0Div1Div0Button0ButtonProps ?? {})}>
                                        <i className="fas fa-times" />
                                    </button>
                                ))}
                            </div>
                            <HeaderNav menus={menus} />
                            <div className="header-items">
                                <div className="about-popup-item border-0 pb-0">
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div0H30H3Visible, divHeader0Div0Nav0Div1Div1Div0H30H3Renderer, (
                                        <h3 className="title" {...(divHeader0Div0Nav0Div1Div1Div0H30H3Props ?? {})}>{divHeader0Div0Nav0Div1Div1Div0H30H3Text}</h3>
                                    ))}
                                    {renderCollectionNode(
                                        heroSectionSupport3s,
                                        (item: HeroSectionSupport3sItem) => (
                                            <div className={item.className} key={item.key}>
                                                <div className={item.div0ClassName ?? "avatar avatar-lg bg-primary rounded-circle"}>
                                                    <i className={item.i0ClassName} />
                                                </div>
                                                <div>
                                                    <p className={item.p0ClassName ?? "title"}>{item.p0Text}</p>
                                                    {renderItemNode(heroSectionSupport3sH3Visible, heroSectionSupport3sH3Renderer, item, (
                                                        <h3 className={item.h30ClassName ?? "link"} {...(typeof heroSectionSupport3sH3Props === "function" ? heroSectionSupport3sH3Props(item) : (heroSectionSupport3sH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>{item.h30Text}</h3>
                                                    ))}
                                                </div>
                                            </div>
                                        ),
                                        heroSectionSupport3sItemWrapper,
                                        heroSectionSupport3sRenderer
                                    )}
                                </div>
                                <div className="about-popup-item border-0 pb-0">
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div1H30H3Visible, divHeader0Div0Nav0Div1Div1Div1H30H3Renderer, (
                                        <h3 className="title" {...(divHeader0Div0Nav0Div1Div1Div1H30H3Props ?? {})}>{divHeader0Div0Nav0Div1Div1Div1H30H3Text}</h3>
                                    ))}
                                    <ul className="d-flex align-items-center gap-2 social-iyem">
                                        {renderCollectionNode(
                                            heroSectionUls,
                                            (item: HeroSectionUlsItem) => (
                                                <li key={item.key}>
                                                    {renderItemNode(heroSectionUlsLinkVisible, heroSectionUlsLinkRenderer, item, (
                                                        <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "social-icon"} aria-label={item.ariaLabel} {...(typeof heroSectionUlsLinkProps === "function" ? heroSectionUlsLinkProps(item) : (heroSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                            <i className={item.className} />
                                                        </SmartLink>
                                                    ))}
                                                </li>
                                            ),
                                            heroSectionUlsItemWrapper,
                                            heroSectionUlsRenderer
                                        )}
                                    </ul>
                                </div>
                                <div className="header-items-button">
                                    {renderCollectionNode(
                                        heroSectionBtnBtnPrimaries,
                                        (item: HeroSectionBtnBtnPrimariesItem) => (
                                            renderItemNode(heroSectionBtnBtnPrimariesLinkVisible, heroSectionBtnBtnPrimariesLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "all_routes.login"} className={item.className ?? "btn btn-primary"} aria-label={item.ariaLabel} {...(typeof heroSectionBtnBtnPrimariesLinkProps === "function" ? heroSectionBtnBtnPrimariesLinkProps(item) : (heroSectionBtnBtnPrimariesLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                    <i className={item.i0ClassName ?? "isax isax-lock-1 me-2"} />
                                                    {item.linkText}
                                                </SmartLink>
                                            ))
                                        ),
                                        heroSectionBtnBtnPrimariesItemWrapper,
                                        heroSectionBtnBtnPrimariesRenderer
                                    )}
                                    {renderNode(divHeader0Div0Nav0Div1Div1Div2Link2LinkVisible, divHeader0Div0Nav0Div1Div1Div2Link2LinkRenderer, (
                                        <SmartLink href={divHeader0Div0Nav0Div1Div1Div2Link2LinkHref} className="btn btn-secondary" {...(divHeader0Div0Nav0Div1Div1Div2Link2LinkProps ?? {})}>
                                            <i className="isax isax-user-tick4 me-2" />
                                            {divHeader0Div0Nav0Div1Div1Div2Link2LinkText}
                                        </SmartLink>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="nav header-navbar-rht">
                            {renderNode(divHeader0Div0Nav0Div2Link0LinkVisible, divHeader0Div0Nav0Div2Link0LinkRenderer, (
                                <SmartLink href={divHeader0Div0Nav0Div2Link0LinkHref} className="btn btn-white" {...(divHeader0Div0Nav0Div2Link0LinkProps ?? {})}>
                                    {divHeader0Div0Nav0Div2Link0LinkText}
                                    {" "}
                                    <span className="icon">
                                        <i className="isax isax-arrow-right-1" />
                                    </span>
                                </SmartLink>
                            ))}
                        </div>
                    </nav>
                </div>
            </header>
            <section className="banner-section-fifteen">
                <div className="container">
                    <div className={divSection0Div0Div0ClassName ?? "row"}>
                        <div className="col-xl-6 col-lg-8">
                            <div className="banner-content-fifteen wow fadeInUp" data-wow-duration={divSection0Div0Div0Div0Div0DivDataWowDuration}>
                                {renderNode(divSection0Div0Div0Div0Div0H10H1Visible, divSection0Div0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="title" {...(divSection0Div0Div0Div0Div0H10H1Props ?? {})}>
                                        {divSection0Div0Div0Div0Div0H10H1Text}
                                        {" "}
                                        <span className="break-line">
                                            {" "}
                                            <span className="line">{divSection0Div0Div0Div0Div0H10Span0Span0SpanText}</span>
                                            {divSection0Div0Div0Div0Div0H10Span0SpanText}
                                            {" "}
                                        </span>
                                        {" "}
                                    </h1>
                                ))}
                                <p className="description">{divSection0Div0Div0Div0Div0P0PText}</p>
                                <div className="banner-btn">
                                    {renderNode(divSection0Div0Div0Div0Div0Div0Link0LinkVisible, divSection0Div0Div0Div0Div0Div0Link0LinkRenderer, (
                                        <SmartLink href={divSection0Div0Div0Div0Div0Div0Link0LinkHref} className="btn btn-white" {...(divSection0Div0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                            {divSection0Div0Div0Div0Div0Div0Link0LinkText}
                                            {" "}
                                            <span className="icon">
                                                <i className="isax isax-arrow-right-1" />
                                            </span>
                                        </SmartLink>
                                    ))}
                                    <div className="banner-call">
                                        <div className="call-icon">
                                            <i className="isax isax-call-calling" />
                                        </div>
                                        <div>
                                            <p className="title">{divSection0Div0Div0Div0Div0Div0Div0Div1P0PText}</p>
                                            {renderNode(divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkVisible, divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkRenderer, (
                                                <SmartLink href={divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkHref} className="link" {...(divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkProps ?? {})}>{divSection0Div0Div0Div0Div0Div0Div0Div1Link0LinkText}</SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {renderNode(divImageWithBasePath0ImageVisible, divImageWithBasePath0ImageRenderer, (
                <SmartImage src={divImageWithBasePath0ImageSrc} alt={divImageWithBasePath0ImageAlt} className="img-fluid overlay-img" {...(divImageWithBasePath0ImagePropsSingleton ?? {})} />
            ))}
        </div>
    );
};

export default HomeFifteenHeroSectionGenerated;
